import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';

export type MermaidRenderThemeMode = 'auto' | 'light' | 'dark';

export type MermaidRenderSize = {
  width: number;
  height: number;
};

export type MermaidRenderInput = {
  source: string;
  themeMode: MermaidRenderThemeMode;
  prefersDark: boolean;
  visible: boolean;
  zoom: number;
};

export type MermaidRenderOutput =
  | {
      status: 'ready' | 'degraded';
      svg: string;
      intrinsicSize?: MermaidRenderSize;
    }
  | {
      status: 'empty' | 'deferred' | 'superseded';
    }
  | {
      status: 'invalid' | 'error';
      message: string;
      svg?: string;
      intrinsicSize?: MermaidRenderSize;
    };

export interface MermaidRenderSession {
  dispose(): void;
  render(input: MermaidRenderInput): Promise<MermaidRenderOutput>;
}

export interface MermaidRenderService {
  createSession(): MermaidRenderSession;
}

export const MermaidRenderProvider = createIdentifier<MermaidRenderService>(
  'AffineMermaidRenderProvider'
);

export function MermaidRenderExtension(
  service: MermaidRenderService
): ExtensionType {
  return {
    setup: di => {
      di.addImpl(MermaidRenderProvider, () => service);
    },
  };
}
